import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { useParams } from "react-router-dom";

const articles = [
  {
    no: 1,
    title: "에스휴먼헬스케어, 모디엠과 소변 기반 스마트 자가검사 키트 사업 위한 MOU",
    description: "[메디컬투데이=최민석 기자] 에스휴먼헬스케어(대표 김도형)는 모디엠(대표 박현열)과 최근 소변 기반 스마트 자가검사 키트인 S휴먼헬스케어 사업 번영을 위한 업무협약(MOU)을 체결했다고 6일 밝혔다. 양사는 건강과 노화에 관심이 증가하는 것에 반해 국내 의료 사각지대가 확대되는 등 건강 및 복지 관련 사회 문제가 수면위로 떠오르자, 기업의 역량이 필요한 시기라고 생각했다. 이에 해결책을 제시하기 위해 양사의 기술과 경험을 통합해 S휴먼헬스케어를 개발했다고 밝혔다. S휴먼헬스케어는 요 시험지를 통해 내 몸의 건강상태를 알 수 있는 기본 소변 검사 10종과 체내 MDA(Malondialdehyde) 농도를 측정해 산화(노화 진행) 정도를 알 수 있는 활성산소 검사 두 가지로 구성돼 있다. 사용 방법은 요 시험지에 소변을 적시고 S휴먼헬스케어 모바일 앱을 통해 촬영하면 1~3분 이내 결과가 나온다. 또한 검사 결과는 휘발성으로 사라지는 것이 아니라 축적되기 때문에 시간이 지나면 내 몸의 상태 변화 추이를 알 수 있다. 이는 바쁜 일상으로 인해 건강관리를 소홀히 할 수밖에 없는 현대인들을 위한 것으로 남녀노소 누구나 스마트폰만 가지고 있다면, 언제 어디서든 쉽고 간단하게 검사할 수 있도록 구성했다. S휴먼헬스케어는 올해 연말에 정식 출시할 예정이다. 상품 출시 판매에 그치는 것이 아니라 향후 고객의 소리를 듣고 이에 대해 고객 맞춤형 서비스를 지속적으로 확장해 나가고, 내년부터는 본격적으로 해외시장에 진출할 예정이다. 에스휴먼헬스케어 관계자는 “에스휴먼헬스케어는 모바일 앱을 이용한 소변검사 제품 중 상품의 다양성 등 차별화를 바탕으로 국내뿐만 아니라 해외 진출을 앞두고 있는 동종업계 선두주자다. 이를 발판으로 삼아 성장해 코스닥 상장을 목표로 하고 있다”고 말했다.",
    info: "에스휴먼헬스케어와 모디엠이 지난 10월 17일 소변 기반 스마트 자가검사 키트인 S휴먼헬스케어 사업 번영을 위한 업무 협약식을 가졌다. (사진=에스휴먼헬스케어 제공)",
    date: "2023-11-06 17:11:30",
    author: "메디컬투데이 최민석 기자(august@mdtoday.co.kr)",
    imageUrl: "https://mdtcdn.iwinv.biz/news/data/20231106/p1065600120482088_834_thum.jpg",
    newsUrl: "https://mdtoday.co.kr/news/view/1065600120482088"
  },
  {
    no: 2,
    title: "에스휴먼헬스케어, 모디엠과 소변 기반 스마트 자가검사 키트 사업 위한 MOU 체결",
    description: "[바이오타임즈] 에스휴먼헬스케어(대표 김도형)는 모디엠(대표 박현열)과 손잡고 지난달 17일 소변 기반 스마트 자가검사 키트인 S휴먼헬스케어 사업 번영을 위한 업무협약(MOU)을 체결했다고 7일 밝혔다. 양사는 건강과 노화에 관심이 증가하는 것에 반해 국내 의료 사각지대가 확대되는 등 건강 및 복지 관련 사회 문제가 수면위로 떠오르자, 기업의 역량이 필요한 시기라고 생각했다. 이에 해결책을 제시하기 위해 양사의 기술과 경험을 통합해 S휴먼헬스케어를 개발했다. S휴먼헬스케어는 요 시험지를 통해 내 몸의 건강상태를 알 수 있는 기본 소변 검사 10종과 체내 MDA(Malondialdehyde) 농도를 측정해 산화(노화 진행) 정도를 알 수 있는 활성산소 검사 두 가지로 구성돼 있다. 사용 방법은 요 시험지에 소변을 적시고 S휴먼헬스케어 모바일 앱을 통해 촬영하면 1~3분 이내 결과가 나온다. 검사 결과는 휘발성으로 사라지는 것이 아니라 축적되기 때문에 시간이 지나면 내 몸의 상태 변화 추이를 알 수 있다. 이는 바쁜 일상으로 인해 건강관리를 소홀히 할 수 밖에 없는 현대인들을 위한 것으로 남녀노소 누구나 스마트 폰만 가지고 있다면, 언제 어디서든 쉽고 간단하게 검사 할 수 있도록 구성했다. S휴먼헬스케어는 올해 연말에 정식 출시할 예정이다. 상품 출시 판매에 그치는 것이 아니라 향후 고객의 소리를 듣고 이에 대해 고객 맞춤형 서비스를 지속적으로 확장해 내년부터는 본격적으로 해외시장에 진출할 계획이다. 에스휴먼헬스케어 관계자는 “에스휴먼헬스케어 모바일 앱을 이용한 소변검사 제품 중 상품의 다양성 등 차별화를 바탕으로 국내뿐만 아니라 해외 진출을 앞두고 있는 동종업계 선두주자”라며 “이를 발판으로 성장해 코스닥 상장을 목표로 하고 있다”고 전했다.",
    info: "사진=S휴먼헬스케어",
    date: "2023-11-07 11:22",
    author: "바이오타임즈 정민아 기자(news@biotimes.co.kr)",
    imageUrl: "https://www.biotimes.co.kr/news/photo/202311/12702_15979_2223.jpg",
    newsUrl: "https://www.biotimes.co.kr/news/articleView.html?idxno=12702"
  },
]

export default function News() {
  const { no } = useParams();
  return (
    <div className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{articles[no - 1].title}</h1>
        <div className="mt-10 max-w-3xl">
          <p className="text-gray-600 text-sm">
            <span>&nbsp;{articles[no - 1].author} &nbsp;</span>
            <span>{articles[no - 1].date}</span>
          </p><hr />
          <figure className="mt-16">
            <img
              className="aspect-video rounded-xl bg-gray-50 object-cover mx-auto"
              src={articles[no - 1].imageUrl}
              alt=""
            />
            <figcaption className="mt-4 flex gap-x-2 text-sm leading-6 text-gray-500">
              <InformationCircleIcon className="mt-0.5 h-5 w-5 flex-none text-gray-300" aria-hidden="true" />
              {articles[no - 1].info}
            </figcaption>
          </figure>

          <p className="mt-8">
            {articles[no - 1].description}
          </p>
          <p className="mt-7">
            {articles[no - 1].author}
          </p>
          <p className="mt-11 text-gray-600 text-sm">
            출처 | {articles[no - 1].newsUrl}
          </p>
        </div>
      </div>
    </div>
  )
}
